import React, { Component, useState } from "react";
import { LargeButton, Input, Ptag, InputBox } from "../core";
import styled from "styled-components";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { colors } from "theme";
import showPassword from "../../assets/images/view.png";
import hidePassword from "../../assets/images/hide.png";
import maskGroup from "../../assets/images/mask_group.png";
import careManager from "../../assets/svgs/care_manager.svg";
import vitalLogo from "../../assets/svgs/vitalLogo.svg";
import neo_insurance from "../../assets/svgs/neoInsuranceBrokingLogo.svg";
import http from "../../services/httpService";
import auth from "../../services/authService";
import { Navigate } from "react-router-dom";
import SideBanner from "pages/corporate/Login/SideBanner";

const Authorisation = (InputComponent) => {
  return class extends Component {
    constructor(props) {
      super(props);
      const userId = localStorage.getItem("user_id");
      this.state = {
        isAuth: !!userId,
        viewPassword: false,
        createAccount: false,
        forgetPassword: false,
      };
    }

    componentDidMount() {}

    toggleViewPassword = () => {
      this.setState({ viewPassword: !this.state.viewPassword });
    };
    redirectToSignUP = () => {
      this.setState({ createAccount: true });
    };
    redirectToForgetPassword = () => {
      this.setState({ forgetPassword: true });
    };

    renderInput = ({
      name,
      placeholder,
      type,
      formikProps,
      length = 70,
    } = {}) => {
      const { errors, touched, handleBlur, values, handleChange } = formikProps;
      const error = touched[name] && errors[name];
      const { viewPassword } = this.state;
      const mutatedType =
        type === "password" ? (viewPassword ? "text" : type) : type;
      return (
        <InputContainer>
          <InputBox
            value={values[name]}
            style={{ padding: "0rem 2rem" }}
            name={name}
            placeholder={placeholder}
            type={mutatedType}
            error={error}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {/* {
                    type === 'password' && 
                    <PasswordIndicator src={viewPassword ? showPassword : hidePassword} onClick={this.toggleViewPassword} />
                } */}
        </InputContainer>
      );
    };

    handleSubmit = async (values, formik) => {
      formik.setErrors({});
      try {
        const { data } = await http.post("/users/verify_support_login/", {
          email: values["email"],
          password: values["password"],
        });
        localStorage.setItem("email", values["email"]);
        localStorage.setItem("password", values["password"]);
        localStorage.setItem("auth_token", data.token);
        localStorage.setItem("user_id", data.user_id);
        localStorage.setItem("permission", data.permission);
        if (data.name) localStorage.setItem("name", data.name);
        this.setState({ isAuth: true });
      } catch (e) {
        alert(e.response["data"]);
      }
    };

    renderForm = (formikProps) => {
      return (
        <>
          <Form>
            {this.renderInput({
              name: "email",
              placeholder: "Email",
              type: "text",
              formikProps,
            })}
            <div style={{ height: "20px" }}></div>
            {this.renderInput({
              name: "password",
              placeholder: "Password",
              type: "password",
              formikProps,
            })}
            {/* <Ptag fontSize="16px" fontWeight="700" marginTop="18px"> <u style={{color : "#4A90E2", cursor:"pointer"}} onClick = {this.redirectToForgetPassword}>Forget password?</u></Ptag> */}
            <LargeButton
              type="submit"
              textTransform="none"
              style={{ marginTop: "50px" }}
              label={"Login"}
            />
            {/* <Ptag fontSize="16px" fontWeight="700" marginTop="10px">Don't have an account? <u style={{color : "#4A90E2", cursor:"pointer"}} onClick = {this.redirectToSignUP}>Create One</u></Ptag> */}
          </Form>
        </>
      );
    };

    render() {
      const { isAuth } = this.state;
      let initialValues = {
        email: "",
        password: "",
      };
      let Schema = Yup.object().shape({
        email: Yup.string().email().required("*Required"),
        password: Yup.string().required("*Required"),
      });
      return (
        <>
          {this.state.createAccount && (
            <Navigate to="/signup" replace={false} />
          )}
          {this.state.forgetPassword && (
            <Navigate to="/forgetpassword" replace={false} />
          )}
          {isAuth && auth.getCurrentUser() ? (
            <InputComponent {...this.props} />
          ) : (
            <>
              <Border>
                <MaindInnerDiv>
                    <Divisiontag
                    style={{
                      position: "relative",
                      padding: "10px",
                      backgroundColor: "white",
                      minWidth: "40%",
                      borderTopLeftRadius: "20px",
                      borderBottomLeftRadius: "20px",
                    }}
                  >
                    {/* <img style={{maxWidth: '100%', maxHeight: '100%',position:'obsolute'}} src={maskGroup} />  */}
                    {/* <img
                      style={{
                        maxWidth: "70%",
                        maxHeight: "60%",
                        position: "obsolute",
                      }}
                      src={careManager}
                    /> */}
                    <SideBanner />
                  </Divisiontag>
                  <Divisiontag style={{ minWidth: "60%" }}>
                    <Page>
                      {/* <img src={neo_insurance}/> */}
                      <Ptag
                        style={{ padding: "40px 40px 0.8rem 40px" }}
                        fontSize="20px"
                        fontWeight="700"
                        letterHeight="28px"
                      >
                        Welcome!
                      </Ptag>
                      <Ptag fontSize="14px" fontWeight="500">
                        Login to your account
                      </Ptag>
                      <Alert>
                        <Formik
                          initialValues={initialValues}
                          validationSchema={Schema}
                          enableReinitialize={true}
                          onSubmit={this.handleSubmit}
                          render={this.renderForm}
                        />
                      </Alert>
                    </Page>
                  </Divisiontag>
                
                </MaindInnerDiv>
              </Border>
            </>
          )}
        </>
      );
    }
  };
};

export default Authorisation;

const Page = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
`;
const MaindInnerDiv = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 18px;
  /* overflow: 23px; */
  display: flex;
`;

const Border = styled.div`
  background-color: ${colors.primaryColor};
  display: flex;
  justify-content: center;
  padding: 45px;
  height: 100vh;
`;
const ManagerImage = styled.div`
  display: flex;
  flex-direction: row;
`;
const DivisiontagImg = styled.div`
  background-image: url(${maskGroup});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
`;
const Divisiontag = styled.div`
  max-width: fit-content;
`;

const Alert = styled.div`
  display: flex;
  flex-direction: column;
  padding: 18px;
  border-radius: 8px;
  width: 90%;
`;

const InputContainer = styled.div`
  display: flex;
  margin-bottom: 4px;
`;

const PasswordIndicator = styled.img`
  height: 30px;
  margin-top: 33.5px;
  border-bottom: 2px solid #436ab2;
  padding-bottom: 6px;
`;

const Text = styled.p`
  font-family: "Inter";
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a90e2;
  display: inline;
`;
